var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GraphUtils } from './graph-utils';
export function calculateLeafStateMap(graph, state, properties) {
    var leafStateMap = {};
    var inheritedState = {};
    // handle inheritance of boolean properties 
    var inheritState = function (id) {
        if (GraphUtils.isRoot(graph, id)) {
            // reset inherited state for each graph root
            inheritedState[id] = __assign({}, GraphUtils.getState(graph, id, properties), state[id] || {});
        }
        else {
            // merge state onto inherited parent state
            var parentId = graph.predecessors[id];
            inheritedState[id] = __assign({}, inheritedState[parentId], state[id] || {});
        }
        // record state in leaf state map
        if (GraphUtils.isLeaf(graph, id)) {
            leafStateMap[id] = inheritedState[id];
        }
    };
    // propagate down the tree
    GraphUtils.depthFirst(graph, inheritState);
    // return state of only leaf nodes
    return leafStateMap;
}
